<template>
  <vs-row class="sm:flex-col lg:flex-row">
    <vs-col vs-type="flex" vs-justify="center" class="h-min w-full 2xl:w-9/12">
      <vx-card>
        <div>
          <heading size="h1" style-size="h4">Workplace Safety</heading>
          <p class="my-5">
            Before you can begin your Work Experience, you need to demonstrate that you understand
            the basics of safety in the workplace.
          </p>
          <p class="mb-5">
            To confirm this, you will need to upload a Workplace Safety completion certificate.
            There are a number of ways you can do this:
          </p>
          <vs-tabs alignment="fixed" :value="activeTab" class="overwrite-tabs">
            <vs-tab v-if="ctWhsEnabled" label="School Careers Website">
              <school-careers-website></school-careers-website>
            </vs-tab>
            <vs-tab label="Safe@Work (VIC)">
              <div class="vx-row">
                <div class="vx-col lg:w-1/2 w-full">
                  <p class="my-5">
                    If you are in Victoria, your teacher may specify that you need to complete the
                    Safe@Work module(s). If this is the case, you can access the Safe@Work General
                    Module via the button below.
                  </p>
                  <p class="my-5">
                    Complete the General Module and upload your certificate using the panel on the
                    right.
                  </p>
                  <p class="my-5">
                    You can also upload additional module certificates if your teacher instructs you
                    to.
                  </p>

                  <button
                    @click="openSafeAtWork()"
                    role="link"
                    class="btn btn-primary btn-size-medium w-full lg:w-auto"
                  >
                    Open Safe@Work
                  </button>
                </div>
                <div class="vx-col lg:w-1/2 w-full">
                  <button id="safe-at-work-modal-btn" @click="showSafeWorkVideo">
                    <img
                      alt="how to use safe at work"
                      src="@/assets/images/workplace_safety/safe_work_splash.jpg"
                      class="img-responsive cursor-pointer sm:mt-0 lg:mt-5 sm:mx-0 lg:mx-10"
                    />
                  </button>
                </div>
              </div>
            </vs-tab>
            <vs-tab label="Other Certificate">
              <div class="mt-10">
                <p class="mb-5">
                  Your teacher may want you to complete another Workplace Safety preparation
                  activity that is not listed here.
                </p>
                <p class="mb-5">
                  If that is the case, you can complete that as directed by your teacher and then
                  upload the certificate using the panel on the right.
                </p>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </vx-card>
    </vs-col>
    <vs-col
      vs-type="flex"
      vs-justify="center"
      class="h-min w-full 2xl:w-3/12 2xl:pl-10 pt-10 2xl:pt-0"
    >
      <vx-card>
        <div class="lg:flex 2xl:block gap-8">
          <div class="w-full lg:w-6/12 2xl:w-full">
            <div v-if="uploadedCertificateUrl != false">
              <h4>View Uploaded Certificate</h4>
              <view-uploaded-certificate />
            </div>
            <div v-else>
              <h4>Upload Certificate</h4>
              <upload-certificate />
            </div>
          </div>
          <div class="w-full lg:w-6/12 2xl:w-full">
            <h4>Upload Additional Certificates</h4>
            <upload-certificate-other />
            <uploaded-other-certificates />
            <p class="mt-3">
              Use this button to upload any additional certificates your teacher may request (eg.
              Construction White Card etc.)
            </p>
          </div>
        </div>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import store from '@/store/store';
import themeConfig from '@/../themeConfig';
import SchoolCareersWebsite from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/SchoolCareersWebsite';
import ViewUploadedCertificate from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/ViewUploadedCertificate';
import UploadCertificate from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/UploadCertificate';
import UploadCertificateOther from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/UploadCertificateOther';
import UploadedOtherCertificates from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/UploadedOtherCertificates';
import router from '@/router/router';

export default {
  components: {
    SchoolCareersWebsite,
    ViewUploadedCertificate,
    UploadCertificate,
    UploadCertificateOther,
    UploadedOtherCertificates,
  },
  data() {
    return {
      showVideoPopup: false,
      videoCode: '',
      contentWidth: themeConfig.contentWidth,
      sidebarWidth: themeConfig.sidebarWidth,
    };
  },
  methods: {
    closePopup() {
      this.showVideoPopup = false;
    },
    openVideoPopup(videoCode) {
      this.$store.commit('updateExperiencePopupVideo', videoCode);
      this.showVideoPopup = true;
    },
    showSafeWorkVideo() {
      // An mp4 in an <iframe> had no title and no way to carry captions (audit 35.1, 9.1,
      // 10.1). The video popup renders a real <video> and picks up the .vtt beside the MP4.
      store.dispatch('popup/showVideoPopup', {
        src:
          $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL +
          '/' +
          'content/workplace_safety/safe_at_work.mp4',
        title: 'How to use safe@work',
      });
      store.commit('popup/setFocusElemOnPopupClose', 'safe-at-work-modal-btn');
    },
    openSafeAtWork() {
      window.open(
        'https://www.education.vic.gov.au/school/students/beyond/Pages/generalmodule.aspx',
        '_blank',
      );
    },
  },
  computed: {
    uploadedCertificateUrl() {
      return store.getters['authStudent/preworkWorkplaceSafety'];
    },
    activeTab() {
      if (location.hash == '#quiz') return 1;
      return 0;
    },
    ctWhsEnabled() {
      return store.getters['authStudent/ctWhsEnabled'];
    },
  },
  mounted() {
    if (
      typeof this.settings['workplace_safety'] !== 'undefined' &&
      this.settings['workplace_safety'] == false
    ) {
      router.push('/student/dashboard');
    }
  },
  provide() {
    return {
      close: this.closePopup,
      video: this.videoCode,
    };
  },
};
</script>

<style scoped>
.h-min {
  height: min-content;
}

button {
  border: none;
}
</style>
